import React, { Component } from "react";
import { Link } from 'react-router-dom';
import "./Alerts.css";

class Alerts extends Component {
  render() {
    return (
      <div className="Alerts">
        <p>    
          <div className="anim"><Link to="/video">L'été se déguste aussi avec les yeux. Cliquez-içi pour regarder ! 🎥</Link></div>
          {/* <img src={flag}  className="flag" alt="drapeau francais" title="france" /> */}
        </p>
      </div>
    );
  }
}

export default Alerts;